/** @jsx jsx */
import { Box, jsx } from "theme-ui";
import React, { useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { CopyrightQuery } from "../../../graphql-types";

export const Copyright: React.FC = () => {
  const { businessName } =
    useStaticQuery<CopyrightQuery>(query).contentfulSiteSettings;
  const [year] = useState(new Date().getFullYear());
  return (
    <Box sx={{ color: "white", fontSize: [1] }}>
      ©{year} {businessName} All Rights Reserved
    </Box>
  );
};

export default Copyright;
const query = graphql`
  query Copyright {
    contentfulSiteSettings {
      businessName
    }
  }
`;
